const getExternalProps = {
  loads: (_, shipmentKey, loadKey, fieldKey) => ({
    shipmentKey,
    loadKey,
    fieldKey,
  }),
  order: (_, shipmentKey, stopType, timeParam) => ({
    shipmentKey,
    stopType,
    timeParam,
  }),
  orders: (_, orderId) => ({
    orderId,
  }),
  warnings: (_, { shipmentKey }) => ({
    shipmentKey,
  }),
  shipments: (_, shipmentKey, stopType, timeParam) => ({
    shipmentKey,
    stopType,
    timeParam,
  }),
};
export { getExternalProps };
export default undefined;
